export default "__VITE_ASSET__c26aece7__"